export const ERROR_UPDATING_COMPANY_DETAILS = 'There was a problem while updating the company details';
export const SUCCESS_UPDATING_COMPANY_DETAILS = 'The company details were updated successfully';

export const ERROR_UPLOADING_LOGO = 'There was a problem while uploading the company logo';
export const ERROR_UPLOADING_ICON = 'There was a problem while uploading the company icon';
export const COMPANY_LOGO_PROP = 'companySettings.logo';
export const COMPANY_ICON_PROP = 'companySettings.icon';

export const SUCCESS_CREATING_INFORMATION_REQUEST = 'Information request created successfully';
export const ERROR_CREATING_INFORMATION_REQUEST = 'Error sending information request';

export const SUCCESS_CREATING_NEW_DOCUMENTS = 'New documents added successfully';
export const ERROR_CREATING_NEW_DOCUMENTS = 'Error adding new documents';
export const SUCCESS_MODIFYING_INFORMATION_REQUEST = 'Information request was modified';
export const SUCCESS_DISMISSING_REQUESTED_DOCUMENT = 'Requested document was dismissed';
export const ERROR_DISMISSING_REQUESTED_DOCUMENT = 'Error dismissing requested document';
export const SUCCESS_DELETING_REQUESTED_QUESTION = 'Question removed successfully';
export const ERROR_DELETING_REQUESTED_QUESTION = 'Error removing question';
export const NO_INFORMATION_AVAILABLE_FOR_REPORT_DATE = 'No report is associated with this company yet';

export const createItemSuccessMessage = (entity: string) => `${entity} created successfully`;
export const createItemErrorMessage = (entity: string) => `Error creating ${entity}`;
export const updateItemSuccessMessage = (entity: string) => `${entity} updated successfully`;
export const updateItemErrorMessage = (entity: string) => `Error updating ${entity}`;

export const DISABLED_TOOLTIP = 'This report has not been approved for clients yet. Please reach your report manager for an status update.';
export const APPROVED_FOR_CLIENTS_TOOLTIP = 'The client can access the report from their user account. See Settings > User Management > Invite User.';
export const DRAFT_TOOLTIP = 'The report is not yet approved for clients. It can be approved from the save button dropdown.';
